module.exports = __webpack_public_path__ + "static/media/viviendas2.39d79a4c.jpg";